



class SimpleCarousel extends Backbone.View {

    get events() {
        return {
            'click .next': '_handle_next_slide',
            'click .previous': '_handle_previous_slide'
        };
    };

    initialize () {
        this._init_carousel();
        if (this.total_width > this.frame_width) {
            return this._activate();
        }
    };

    _init_carousel () {
        this.inner = $(this.el).find('.inner > ul');
        this.frame_width = $(this.el).width();
        this.total_width = this._get_total_width();
        this.current_scroll = 0;

        this._scroll_carousel(0);
    };

    _activate () {
        $(this.el).find('.inner')
                  .append('<div class="previous disabled"><i class="icon-arrow-left"></i></div>')
                  .append('<div class="next"><i class="icon-arrow-right"></i></div>');

        $(window).resize(() => {
            if (this.frame_width !== $(this.el).width()) {
                this._init_carousel();
            }
        });
    };

    _handle_next_slide (e) {
        e.preventDefault();

        if (-this.current_scroll + this.frame_width < this.total_width) {
            this._scroll_carousel(-this.frame_width);
        }
    };

    _handle_previous_slide (e) {
        e.preventDefault();

        if (-this.current_scroll - this.frame_width >= 0) {
            this._scroll_carousel(this.frame_width);
        }
    };

    _scroll_carousel (distance) {
        this.current_scroll += distance;
        this.inner.animate({
            marginLeft: this.current_scroll
        }, 400);
        this._update_controls_ui();
        this._pause_videos();
    };

    _update_controls_ui () {
        $(this.el).find('.previous, .next').addClass('disabled');
        // buffer to prevent extra slide on iphone due to padding inconsistencies
        if (-this.current_scroll + this.frame_width < this.total_width - 5) {
            $(this.el).find('.next').removeClass('disabled');
        }
        if (-this.current_scroll - this.frame_width >= 0) {
            $(this.el).find('.previous').removeClass('disabled');
        }
    };

    _pause_videos () {
        $('video').each(function() {
            this.pause();
        });
    };

    _get_total_width () {
        let w = 0;
        this.inner.find('> li').each(function() {
            w += $(this).outerWidth();
        });
        return w;
    };

};

$(function() {
    $('.simple-carousel').each(function() {
        new SimpleCarousel({
            el: this
        });
    });
});



// WEBPACK FOOTER //
// ./assets/es6/common/simple_carousel.es6